webpackJsonp([276831373436262],{

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AudioPlayer = __webpack_require__(40);
	
	var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);
	
	var _style = __webpack_require__(162);
	
	var _shared = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TheBurningGlassHeaderSection = function TheBurningGlassHeaderSection(_ref) {
	  var content = _ref.content;
	  return _react2.default.createElement(
	    _style.Wrapper,
	    null,
	    _react2.default.createElement(
	      _style.InfoWrapper,
	      null,
	      _react2.default.createElement(
	        _style.Content,
	        null,
	        content(),
	        _react2.default.createElement(
	          "div",
	          { className: "the-burning-glass" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Preview 3 songs from the upcoming album",
	            _react2.default.createElement("br", null),
	            " \u2014 Child and Wattle Tree / Dark Gift / The Watcher"
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://nausicaa-music.bandcamp.com/album/child-and-wattle-tree-dark-gift-the-watcher",
	                  target: "_blank"
	                },
	                "Bandcamp"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://music.apple.com/au/album/child-and-wattle-tree-dark-gift-the-watcher-single/1850647359",
	                  target: "_blank"
	                },
	                "Apple Music"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "https://open.spotify.com/album/12MiUANZ2WzSYjMjcAn1Iy",
	                  target: "_blank"
	                },
	                "Spotify"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "sub" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "released October 31, 2025"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Words by Judith Wright ",
	              _react2.default.createElement("br", null),
	              "Music by Simon Munro ",
	              _react2.default.createElement("br", null),
	              "Produced by Greg Walker"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Mixed by Adam Selzer ",
	              _react2.default.createElement("br", null),
	              " Mastered by William Bowden"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "All songs to appear on the upcoming album, The Burning Glass.",
	              " "
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_style.StyledImage, {
	      src: "/images/the-burning-glass-bg/tgb_bg.webp",
	      alt: "Background Image",
	      loader: function loader(_ref2) {
	        var isLoaded = _ref2.isLoaded;
	        return _react2.default.createElement(_shared.Loader, { isLoaded: isLoaded });
	      },
	      sources: [{
	        srcset: ["/images/the-burning-glass-bg/tbg_bg.avif 1x", "/images/the-burning-glass-bg/tbg_bg@2x.avif 2x", "/images/the-burning-glass-bg/tbg_bg.webp 1x", "/images/the-burning-glass-bg/tbg_bg@2x.webp 2x", "/images/the-burning-glass-bg/tbg_bg.jpg 1x", "/images/the-burning-glass-bg/tbg_bg@2x.jpg 2x"]
	      }]
	    })
	  );
	};
	
	exports.default = TheBurningGlassHeaderSection;
	module.exports = exports["default"];

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Content = exports.InfoWrapper = exports.StyledImage = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: repeat(5, 1fr);\n  position: relative;\n  height: 100vh;\n  height: 100lvh;\n  grid-gap: 1rem;\n  padding: 1rem;\n  ", "\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: repeat(5, 1fr);\n  position: relative;\n  height: 100vh;\n  height: 100lvh;\n  grid-gap: 1rem;\n  padding: 1rem;\n  ", "\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 3rem;\n  "], ["\n  padding: 3rem;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: repeat(5, 1fr);\n    padding: 1.5rem;\n  "], ["\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: repeat(5, 1fr);\n    padding: 1.5rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  grid-area: 1 / 3 / 5 / 9;\n  position: relative;\n  overflow: hidden;\n  margin: -1rem;\n\n  img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    top: -100%;\n    right: -100%;\n    bottom: -100%;\n    left: -100%;\n    display: block;\n    object-fit: contain;\n    object-position: center;\n    z-index: 2;\n    ", "\n  }\n\n  ", "\n  ", "\n"], ["\n  grid-area: 1 / 3 / 5 / 9;\n  position: relative;\n  overflow: hidden;\n  margin: -1rem;\n\n  img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    top: -100%;\n    right: -100%;\n    bottom: -100%;\n    left: -100%;\n    display: block;\n    object-fit: contain;\n    object-position: center;\n    z-index: 2;\n    ", "\n  }\n\n  ", "\n  ", "\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n\n    "], ["\n\n    "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  margin: -3rem;\n  "], ["\n  margin: -3rem;\n  "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  margin: -1.5rem;\n    grid-area: 1 / 5 / 4 / 1;\n    &:before {\n      padding-top: 100%;\n    }\n  "], ["\n  margin: -1.5rem;\n    grid-area: 1 / 5 / 4 / 1;\n    &:before {\n      padding-top: 100%;\n    }\n  "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  grid-row: 5 / 5;\n  grid-column: 2 / 6;\n  z-index: 3;\n  align-self: center;\n  ", "\n  ", "\n  .sub {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    font-size: 0.88rem;\n    line-height: 1.25;\n    gap: 2rem;\n    margin-top: 1rem;\n    p {\n      margin: 0;\n      width: 45%;\n    }\n  }\n"], ["\n  grid-row: 5 / 5;\n  grid-column: 2 / 6;\n  z-index: 3;\n  align-self: center;\n  ", "\n  ", "\n  .sub {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    font-size: 0.88rem;\n    line-height: 1.25;\n    gap: 2rem;\n    margin-top: 1rem;\n    p {\n      margin: 0;\n      width: 45%;\n    }\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  grid-row: 5 / 6;\n    grid-column: 1 / 5;\n    align-self: center;\n  "], ["\n  grid-row: 5 / 6;\n    grid-column: 1 / 5;\n    align-self: center;\n  "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  align-self: start;\n\n    /* padding: 0 2rem; */\n  "], ["\n  align-self: start;\n\n    /* padding: 0 2rem; */\n  "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n  margin-top: 1rem;\n  line-height: 1.8em;\n  color: ", ";\n  .windermere {\n    text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.4);\n    color: #fff;\n    a {\n      border-bottom-color: #fff;\n      &:hover {\n        border-bottom: 1px solid #fff;\n      }\n    }\n  }\n  ", "\n\n  h1 {\n    font-weight: 400;\n  }\n\n  p {\n    margin: 1.5rem 0;\n  }\n\n  a {\n    color: #fff;\n    border-bottom: 1px dotted ", ";\n\n    &:hover {\n      border-bottom-color: ", ";\n    }\n  }\n"], ["\n  margin-top: 1rem;\n  line-height: 1.8em;\n  color: ", ";\n  .windermere {\n    text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.4);\n    color: #fff;\n    a {\n      border-bottom-color: #fff;\n      &:hover {\n        border-bottom: 1px solid #fff;\n      }\n    }\n  }\n  ", "\n\n  h1 {\n    font-weight: 400;\n  }\n\n  p {\n    margin: 1.5rem 0;\n  }\n\n  a {\n    color: #fff;\n    border-bottom: 1px dotted ", ";\n\n    &:hover {\n      border-bottom-color: ", ";\n    }\n  }\n"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n    margin-top: 1rem;\n  "], ["\n    margin-top: 1rem;\n  "]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.section(_templateObject, _constants.media.md(_templateObject2), _constants.media.sm(_templateObject3));
	
	var StyledImage = exports.StyledImage = (0, _styledComponents2.default)(_Image2.default)(_templateObject4, _constants.media.sm(_templateObject5), _constants.media.md(_templateObject6), _constants.media.sm(_templateObject7));
	
	var InfoWrapper = exports.InfoWrapper = _styledComponents2.default.header(_templateObject8, _constants.media.md(_templateObject9), _constants.media.sm(_templateObject10));
	
	var Content = exports.Content = _styledComponents2.default.main(_templateObject11, _constants.colors.gray500, _constants.media.sm(_templateObject12), _constants.colors.gray500, _constants.colors.red500);

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.windermereQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TheBurningGlassHeaderSection = __webpack_require__(161);
	
	var _TheBurningGlassHeaderSection2 = _interopRequireDefault(_TheBurningGlassHeaderSection);
	
	var _Head = __webpack_require__(30);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _constants = __webpack_require__(31);
	
	var _shared = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* stylelint-enable */
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var clients = data.clients,
	      events = data.events,
	      mentions = data.mentions,
	      articles = data.articles;
	
	
	  return _react2.default.createElement(
	    _shared.ContentWrapper,
	    null,
	    _react2.default.createElement(_Head2.default, _extends({}, _constants.META.profile, { image: _constants.META.common.image })),
	    _react2.default.createElement(_TheBurningGlassHeaderSection2.default, { content: function content() {
	        return _react2.default.createElement(_react.Fragment, null);
	      } })
	  );
	};
	
	var windermereQuery = exports.windermereQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-the-burning-glass-js-cf52f20e4c0bc9f791d2.js